import {
  Accordion as ChakraAccordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  Box
} from '@chakra-ui/react';
import Children from 'react-children-utilities';

type AccordionProps = {
  titles: string[];
  heading: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

export const Accordion: React.FC<React.PropsWithChildren<AccordionProps>> = ({
  children,
  titles,
  heading
}) => (
  <ChakraAccordion allowMultiple>
    {Children.map(children, (child, index) => {
      const title = titles[index];

      return (
        <AccordionItem key={title}>
          <Box as={heading}>
            <AccordionButton>
              <Box as="span" flex="1" textAlign="left" dangerouslySetInnerHTML={{ __html: title }} />
              <AccordionIcon />
            </AccordionButton>
          </Box>
          {child}
        </AccordionItem>
      );
    })}
  </ChakraAccordion>
);
